import React from "react";

// The WhatsApp chat preview for templates written here: every type the builder makes (standard, limited-time
// offer, carousel, passcode). shown: the preview's whatsapp block (render() + pictures and place filled).

const ICON = { URL: "↗", PHONE_NUMBER: "✆", COPY_CODE: "⧉", OTP: "⧉", QUICK_REPLY: "↩" };

const Buttons = ({ buttons = [] }) => {
    const list = buttons.map((b) => ({ text: b.optOut ? b.text || "Stop promotions" : b.text, icon: ICON[b.type] || "↩" }));
    const shown = list.length > 3 ? [...list.slice(0, 2), { text: "See all options", icon: "☰" }] : list;
    return shown.map((b, i) => <div key={i} className="kit-pv-wa-btn"><span aria-hidden="true">{b.icon}</span>{b.text || "Button"}</div>);
};

const Media = ({ type, url, place }) => {
    if (type === "IMAGE") return url ? <img src={url} alt="" className="kit-pv-wa-media" /> : <div className="kit-pv-wa-media kit-pv-wa-ph">Image</div>;
    if (type === "VIDEO") return <div className="kit-pv-wa-media kit-pv-wa-video" aria-label="Video"><span>▶</span></div>;
    if (type === "DOCUMENT") return <div className="kit-pv-wa-doc"><span className="kit-pv-wa-pdf">PDF</span><span>Document.pdf</span></div>;
    if (type === "LOCATION") {
        return (
            <div className="kit-pv-wa-loc">
                <div className="kit-pv-wa-map" aria-hidden="true">📍</div>
                <div className="kit-pv-wa-place">{place ? <><strong>{place.name || "Location"}</strong><br />{place.address || `${place.latitude}, ${place.longitude}`}</> : <em>No place yet</em>}</div>
            </div>
        );
    }
    return null;
};

const hoursLabel = (h) => {
    const end = new Date(Date.now() + h * 3600000);
    return `Offer ends ${end.toLocaleDateString(undefined, { day: "numeric", month: "short" })}, ${end.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })}`;
};

const WaChatPreview = ({ shown = {}, time = "15:02" }) => {
    const type = shown.type || "standard";
    const headerType = shown.headerType || "";
    return (
        <div className="kit-pv-wa">
            <div className="kit-pv-wa-bubble">
                {type !== "carousel" && headerType && headerType !== "TEXT" ? <Media type={headerType} url={shown.headerUrl} place={shown.location} /> : null}
                {type === "lto" ? (
                    <div className="te-wa-lto">
                        <span className="te-wa-lto-icon" aria-hidden="true">🎁</span>
                        <div>
                            <div className="fw-semibold">{shown.lto?.text || "Offer title"}</div>
                            {shown.lto?.hasExpiration ? <div className="te-wa-lto-ends">{hoursLabel(shown.lto.expiresInHours || 24)}</div> : null}
                        </div>
                    </div>
                ) : null}
                {headerType === "TEXT" && shown.header ? <div className="kit-pv-wa-head">{shown.header}</div> : null}
                <div className="kit-pv-wa-body">{shown.body || " "}</div>
                {shown.footer ? <div className="kit-pv-wa-foot">{shown.footer}</div> : null}
                <div className="kit-pv-wa-time">{time}</div>
                <Buttons buttons={shown.buttons} />
            </div>
            {type === "carousel" ? (
                <div className="te-wa-cards" aria-label="Cards">
                    {(shown.cards || []).map((c, i) => (
                        <div key={i} className="te-wa-card">
                            <Media type={headerType === "VIDEO" ? "VIDEO" : "IMAGE"} url={c.headerUrl} />
                            <div className="kit-pv-wa-body">{c.body || " "}</div>
                            <Buttons buttons={c.buttons} />
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default WaChatPreview;
